<template>
  <div>
    <a-modal
      v-model="visible"
      title="新建体检信息"
      width="540px"
      @ok="handleOk"
      centered
      okText="手动录入"
      :getContainer="getContainer"
    >
      <div class="content">
        <div>
          <img
            src="@/assets/image/img_sfzlr.png"
            width="200px"
            height="200px"
            alt=""
          />
        </div>
        <div>
          <div class="msg">
            请在 <span>体检设备身份证读取处刷身</span> 后进行体检
          </div>
          <div class="msg">系统将自动同步个类体检数据。</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      this.$emit("addOrUpdateHandle");
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}
.msg {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #4b596a;
  text-align: center;
}
.msg span {
  color: #0073ff;
}
</style>